module.exports = __webpack_public_path__ + "static/media/close.57271585.svg";